import {MenuInput, MenuLabel, MenuSection, MenuWrapper} from "../../../common/menu/TaskMenu";
import React, {useEffect, useState} from "react";
import {Cell, CenterCell, Content, Table} from "../../../common/menu/TaskContent";
import {IColumn} from "../../../interfaces/common";
import * as xlsx from "xlsx";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {RootReducer} from "../../../../redux/reducers";
import * as buttonActions from '../../../../redux/actions/button';
import {Button, Modal} from "react-bootstrap";
import {baseURL} from "../../../../axios";
import { getActiveButtonActions } from '../../../../redux/reducers/button'
import * as changeMenuActions from '../../../../redux/actions/change-menu'

const headers: IColumn[] = [
  { name: '순번', style: { minWidth: '50px', width: '50px', textAlign: 'center' } },
  { name: '품목보고번호', style: { minWidth: '180px', width: '180px', textAlign: 'center' } },
  { name: '품목명', style: { minWidth: '180px', width: '180px', textAlign: 'center' } },
  { name: '제품명', style: { minWidth: '350px', width: '350px', textAlign: 'center' } },
  // { name: '신(보)고일자', style: { minWidth: '180px', width: '180px', textAlign: 'center' } },
  // { name: '생산중단일자', style: { minWidth: '180px', width: '180px', textAlign: 'center' } },
  // { name: '소비기한', style: { minWidth: '350px', width: '350px', textAlign: 'center' } },
  { name: '원재료(배합비)', style: { minWidth: '600px', textAlign: 'center' } }
]

export default function ExcelApply() {
  const [excelData, setExcelData] = useState<any[]>([])

  const [openConfirm, setOpenConfirm] = useState(false);
  const [success, setSuccess] = useState(false);
  const [failed, setFailed] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);

  const btnActions = useSelector((state: RootReducer) => getActiveButtonActions(state, 'excel-apply'), shallowEqual);
  const dispatch = useDispatch();

  function handleUploadFile(e: React.ChangeEvent<HTMLInputElement>) {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      const reader = new FileReader();

      reader.onload = (e: ProgressEvent<FileReader>) => {
        const binaryStr = e.target?.result;
        if (typeof binaryStr === 'string' || binaryStr instanceof ArrayBuffer) {
          const workbook = xlsx.read(binaryStr, { type: 'binary' });
          const sheetName = workbook.SheetNames[0];
          const sheet = workbook.Sheets[sheetName];
          const data = xlsx.utils.sheet_to_json(sheet);

          setExcelData(data);
        }
      };

      reader.readAsBinaryString(file);
    }
  }

  async function handleSaveData() {
    setUploading(true);

    try {
      const response = await fetch(`${baseURL}/api/standard-info/excel`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(excelData),
        credentials: "include",
      });
      const reader = response.body?.getReader();
      const decoder = new TextDecoder('utf-8');

      if (reader) {
        while (true) {
          const { done, value } = await reader.read();
          if (done) {
            reader.releaseLock();
            break;
          }

          const chunk = decoder.decode(value);
          const lines = chunk.trim().split("\n");

          lines.forEach((line) => {
            if (line.startsWith("data:")) {
              const {progress} = JSON.parse(line.slice(5));
              setProgress(Math.round(progress * 100));
            }
          });
        }

        setSuccess(true);
      } else {
        throw new Error("Failed to upload data");
      }
    } catch (e) {
      setFailed(true);
    } finally {
      setUploading(false);
    }
  }

  function handleCloseSuccess() {
    setOpenConfirm(false);
    setSuccess(false);
    setExcelData([]);
  }

  function handleCloseFailed() {
    setOpenConfirm(false);
    setFailed(false);
  }

  useEffect(() => {
    if(btnActions.active) {
      if (btnActions.action === 'save') {
        setOpenConfirm(true);
      }
    }
    dispatch(buttonActions.clear());
  }, [btnActions.active, btnActions.action, dispatch]);

  useEffect(() => {
    if (excelData.length > 0) {
      dispatch(changeMenuActions.change());
    } else {
      dispatch(changeMenuActions.reset());
    }
  }, [excelData, dispatch]);

  useEffect(() => {
    return () => {
      dispatch(changeMenuActions.reset());
    }
  }, [dispatch]);

  return (
    <>
      <MenuWrapper>
        <MenuSection>
          <MenuLabel>파일 등록</MenuLabel>
          <MenuInput
            type='file'
            accept={".xlsx, .xls"}
            onChange={handleUploadFile}
          />
        </MenuSection>
      </MenuWrapper>

      <Content>
        <Table>
          <thead className='sticky-head'>
            <tr>
              {headers.map((header, i) => (
                <th key={i} style={header.style} scope='col'>{header.name}</th>
              ))}
            </tr>
          </thead>

          <tbody>
            {excelData.map((row, index) => (
              <tr key={index}>
                <th className='text-center' scope='row' style={{ verticalAlign: 'middle' }}>{row['순번']}</th>
                <CenterCell>{row['품목보고번호']}</CenterCell>
                <Cell>{row['품목명']}</Cell>
                <Cell>{row['제품명']}</Cell>
                {/*<CenterCell>{row['신(보)고일자']}</CenterCell>*/}
                {/*<CenterCell>{row['생산중단일자']}</CenterCell>*/}
                {/*<Cell>{row['소비기한']}</Cell>*/}
                <Cell>{row['원재료(배합비)']}</Cell>
              </tr>
            ))}
          </tbody>
        </Table>
      </Content>

      <Modal show={openConfirm} centered>
        <Modal.Body>
          선택하신 파일을 업로드 하시겠습니까?
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={() => setOpenConfirm(false)}>
            취소
          </Button>
          <Button variant='primary' onClick={handleSaveData} disabled={uploading}>
            {uploading ? `업로드 중...(${progress}%)` : '확인'}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={success} centered>
        <Modal.Body>
          업로드에 성공하였습니다.
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={handleCloseSuccess}>
            닫기
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={failed} centered>
        <Modal.Body>
          업로드에 실패하였습니다.
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={handleCloseFailed}>
            닫기
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}